<template>
  <div>
    <div
      v-if="$can('update', 'company')"
      class="btn-actions-content d-flex"
    >
      <b-button
        v-if="edit"
        class="d-flex align-items-center mr-3 button-cancel"
        variant="outline-primary"
        @click="cancel()"
      >
        <VSIcons
          name="CloseSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Cancelar</span>
      </b-button>
      <b-button
        v-if="!edit"
        class="btn-grad d-flex align-items-center"
        @click="setEdit(true)"
      >
        <VSIcons
          name="Edit"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Editar</span>
      </b-button>
      <b-button
        v-else
        class="btn-grad d-flex align-items-center"
        @click="saveChanges(companyData)"
      >
        <VSIcons
          name="TickSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Salvar</span>
      </b-button>
    </div>
    <div v-if="!apiInCall">
      <validation-observer ref="form">
        <h6>Dados da empresa</h6>
        <b-form class="mt-3">
          <b-row>
            <b-col>
              <b-form-group
                v-slot="{ ariaDescribedby }"
                label="Pessoa Jurídica"
                :disabled="!edit"
              >
                <b-form-radio-group
                  v-model="companyData.isLegalPerson"
                  :options="optionsLegalPerson"
                  :aria-describedby="ariaDescribedby"
                  name="radio-inline"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="companyData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="CNPJ"
                rules="required|cnpj"
              >
                <b-form-group label="CNPJ">
                  <b-input-group>
                    <b-form-input
                      id="cnpj"
                      v-model="companyData.cnpj"
                      v-mask="'##.###.###/####-##'"
                      :disabled="!edit"
                      type="text"
                      @blur="getDataCompanyByCnpj(companyData.cnpj)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-else
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="CPF"
                rules="required|cpf"
              >
                <b-form-group label="CPF">
                  <b-input-group>
                    <b-form-input
                      id="cpf"
                      v-model="companyData.cpf"
                      v-mask="'###.###.###-##'"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="companyData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nome fantasia"
                rules="required|max:100"
              >
                <b-form-group label="Nome fantasia">
                  <b-input-group>
                    <b-form-input
                      id="nome-fantasia"
                      v-model="companyData.nome_fantasia"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-else
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nome completo"
                rules="required|alpha_spaces|max:100"
              >
                <b-form-group label="Nome Completo">
                  <b-input-group>
                    <b-form-input
                      id="nome-completo"
                      v-model="companyData.full_name"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!companyData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="documento de identificação"
                rules="max:100"
              >
                <b-form-group label="Documento de Identificação">
                  <b-input-group>
                    <b-form-input
                      id="documento-identificacao"
                      v-model="companyData.identification_document"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!companyData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="órgão emissor"
                rules="max:100"
              >
                <b-form-group label="Órgão Emissor">
                  <b-input-group>
                    <b-form-input
                      id="orgao-emissor"
                      v-model="companyData.document_issuer"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!companyData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="setor"
                rules="required"
              >
                <b-form-group label="Setor">
                  <b-form-select
                    id="setor"
                    v-model="companyData.sector.id"
                    :options="sectorOptions"
                    :disabled="!edit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="companyData.isLegalPerson"
            >
              <validation-provider
                v-slot="{ errors }"
                name="razão social"
                rules="required|max:100"
              >
                <b-form-group label="Razão Social">
                  <b-input-group>
                    <b-form-input
                      id="razao-social"
                      v-model="companyData.razao_social"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="companyData.isLegalPerson"
              md="2"
            >
              <b-form-group label="CNAE Principal">
                <b-input-group>
                  <b-form-input
                    id="cnae"
                    v-model="companyData.cnae_principal"
                    v-mask="'##.##-#-##'"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              v-if="companyData.isLegalPerson"
            >
              <b-form-group label="Inscrição Estadual">
                <b-input-group>
                  <b-form-input
                    id="inscricao-estadual"
                    v-model="companyData.inscricao_estadual"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              v-if="companyData.isLegalPerson"
            >
              <b-form-group label="Inscrição Municipal">
                <b-input-group>
                  <b-form-input
                    id="inscricao-municipal"
                    v-model="companyData.inscricao_municipal"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="companyData.isLegalPerson">
            <b-col
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="setor"
                rules="required"
              >
                <b-form-group label="Setor">
                  <b-form-select
                    id="setor"
                    v-model="companyData.sector.id"
                    :options="sectorOptions"
                    :disabled="!edit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!createCompany"
              md="1"
            >
              <b-form-group label="Empreendimento">
                <b-input-group>
                  <b-form-input
                    id="empreendimento"
                    :value="enterpriseQuantity"
                    disabled
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <h6>Endereço da empresa</h6>
        <b-form class="mt-3">
          <b-row>
            <b-col
              md="2"
            >
              <validation-observer ref="cep">
                <validation-provider
                  v-slot="{ errors }"
                  name="CEP"
                  rules="max:9|min:8"
                >
                  <b-form-group label="CEP">
                    <b-input-group>
                      <b-form-input
                        id="cep"
                        v-model="companyData.zip_code"
                        :disabled="!edit"
                        type="text"
                        @blur="getAddress(companyData.zip_code)"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </validation-observer>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Cidade">
                <b-input-group>
                  <b-form-input
                    id="cidade"
                    v-model="companyData.city"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="UF">
                <b-input-group>
                  <b-form-input
                    id="uf"
                    v-model="companyData.state"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Bairro">
                <b-input-group>
                  <b-form-input
                    id="bairro"
                    v-model="companyData.neighborhood"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Endereço">
                <b-input-group>
                  <b-form-input
                    id="endereco"
                    v-model="companyData.address"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Número / Complemento">
                <b-input-group>
                  <b-form-input
                    id="numero"
                    v-model="companyData.address_number"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <h6>Dados do responsável</h6>
        <b-form class="mt-3">
          <b-row>
            <b-col
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nome responsável"
                rules="alpha_spaces|max:50"
              >
                <b-form-group label="Nome">
                  <b-input-group>
                    <b-form-input
                      id="nome-responsavel"
                      v-model="contact.name"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                name="e-mail"
                rules="email|max:50"
              >
                <b-form-group label="E-mail">
                  <b-input-group>
                    <b-form-input
                      id="email-responsavel"
                      v-model="contact.email"
                      :disabled="!edit"
                      type="email"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Departamento">
                <b-input-group>
                  <b-form-input
                    id="departamento-responsavel"
                    v-model="contact.department"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Cargo">
                <b-input-group>
                  <b-form-input
                    id="carg-responsavel"
                    v-model="contact.job_position"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              md="2"
            >
              <b-form-group label="Data de nascimento">
                <b-input-group>
                  <b-form-input
                    id="data-responsavel"
                    v-model="contact.birth_date"
                    :disabled="!edit"
                    type="date"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="telefone"
                rules="phone"
              >
                <b-form-group label="Telefone">
                  <b-input-group>
                    <b-form-input
                      id="telefone-responsavel"
                      v-model="contact.telephone[0].telephone_number"
                      v-mask="maskTelephone(contact.telephone[0].telephone_number)"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <b-form-group label="Marcador">
                <b-form-select
                  id="marcador"
                  v-model="contact.telephone[0].telephone_type"
                  :options="optionsMarcador"
                  :disabled="!edit"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                v-slot="{ errors }"
                name="observações"
                rules="max:180"
              >
                <b-form-group label="Observações">
                  <b-form-textarea
                    id="textarea"
                    v-model="contact.note"
                    rows="2"
                    max-rows="4"
                    :disabled="!edit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-spinner
      v-else
      variant="primary"
      class="general-data-spinner"
    />
  </div>
</template>

<script>
import {
  BForm, BInputGroup, BFormInput, BFormGroup, BRow, BCol, BFormTextarea, BButton, BSpinner, BFormSelect, BFormRadioGroup,
} from 'bootstrap-vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { titleInverse } from '@core/utils/filter'
import { maskPhone } from '@core/mixins/ui/forms'
import VSIcons from '@/assets/icons/VSIcons.vue'
import companies from '@/services/companies'
import { required } from '@/@core/utils/validations/validations'
import contacts from '@/services/contacts'

export default {
  components: {
    BForm, BInputGroup, BFormInput, BFormGroup, BRow, BCol, BFormTextarea, BButton, VSIcons, BSpinner, BFormSelect, BFormRadioGroup,
  },
  filters: {
    titleInverse,
  },
  mixins: [
    maskPhone,
  ],
  data() {
    return {
      required,
      createCompany: false,
      createContact: false,
      optionsLegalPerson: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
      contact: {
        company_id: 0,
        name: '',
        email: '',
        job_position: '',
        department: '',
        birth_date: '',
        note: '',
        telephone: [
          {
            telephone_number: '',
            telephone_type: '',
            whatsapp_icon: false,
            principal_icon: true,
          },
        ],
      },
      companyData: {
        id: null,
        isLegalPerson: true,
        cpf: '',
        document_issuer: '',
        identification_document: '',
        full_name: '',
        nome_fantasia: '',
        razao_social: '',
        cnpj: '',
        cnae_principal: '',
        inscricao_estadual: '',
        inscricao_municipal: '',
        sector: {
        },
        projects: [
        ],
        zip_code: '',
        city: '',
        state: '',
        neighborhood: '',
        address: '',
        address_number: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      edit: 'app/getItemTableEdit',
      apiInCall: 'app/getApiInCall',
      sectorOptions: 'sector/getSectorsOptions',
      companiesOptions: 'company/getCompaniesOptions',
      ufOptions: 'app/getUfOptions',
      optionsMarcador: 'contacts/getOptionsMarcador',
    }),
    enterpriseQuantity() {
      return this.companyData.projects.length
    },
    subTitlePersonLegal() {
      return this.companyData.isLegalPerson ? this.companyData.nome_fantasia : this.companyData.full_name
    },
  },
  created() {
    if (this.verifyRouteAddNewItem()) {
      this.createCompany = true
      this.createContact = true
      this.setSubtitle('')
    } else {
      this.fetchCompany(this.$route.params.id).then(() => { this.createContact = !this.contact.name.length > 0 })
    }
    this.fetchSectors()
    this.fetchCompanies()
  },
  methods: {
    ...mapMutations({ setEdit: 'app/SET_ITEM_TABLE_EDIT', setSubtitle: 'app/SET_SUBTITLE', setCompanyData: 'company/SET_COMPANY_DATA' }),
    ...mapActions({
      fetchSectors: 'sector/fetchSectors',
      fetchCompanies: 'company/fetchCompanies',
      fetchContacts: 'contacts/fetchContacts',
    }),
    fetchCompany(id) {
      return new Promise(resolve => {
        companies.getCompanyById(id).then(res => {
          this.setCompanyData(res.data)
          this.companyData = res.data
          this.setSubtitle(this.subTitlePersonLegal)
          contacts.getContactsByRelationAndId({ relation: 'Company', id: this.$route.params.id }).then(resContact => {
            this.contact.company_id = Number(this.$route.params.id)
            if (resContact.data.filter(arr => arr.isActive).length > 0) {
              // eslint-disable-next-line prefer-destructuring
              this.contact = resContact.data.filter(filterContact => filterContact.isActive && (filterContact.telephone.filter(arrTel => arrTel.principal_icon).length > 0))[0]
            }
            resolve()
          })
        })
      })
    },
    getDataCompanyByCnpj(cnpj) {
      this.getCompanyReceitaByCnpj(cnpj).then(res => {
        this.companyData.nome_fantasia = res.fantasia
        this.companyData.razao_social = res.nome
        this.companyData.cnae_principal = res.atividade_principal[0].code

        const cep = res.cep.replace(/\D/gim, '')
        this.companyData.zip_code = cep
        this.companyData.city = titleInverse(res.municipio)
        this.companyData.address = titleInverse(res.logradouro)
        this.companyData.neighborhood = titleInverse(res.bairro)
        this.companyData.state = res.uf
        this.companyData.address_number = res.numero
      })
    },
    saveChanges(form) {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.createCompany) {
            companies.createCompany(form).then(res => {
              this.setEdit(false)
              this.companyData.id = res.data.id
              this.createCompany = false
              this.setCompanyData(res.data)
              this.saveContact(res.data.id).then(() => { this.createContact = false })
              this.toast({
                title: 'Criado!',
                text: 'Empresa criada com sucesso!',
                variant: 'success',
              })
              this.$router.push(`/empresa/${res.data.id}/detalhes`)
            })
          } else {
            // eslint-disable-next-line no-param-reassign
            delete form.projects
            companies.editCompany(form).then(res => {
              this.setEdit(false)
              this.toast({
                title: 'Atualizado!',
                text: 'Empresa atualizada com sucesso!',
                variant: 'success',
              })
              if (this.createContact) {
                this.saveContact(res.data.id).then(() => { this.createContact = false })
              } else {
                this.editContact()
              }
            })
          }
          this.setSubtitle(this.subTitlePersonLegal)
        }
      })
    },

    saveContact(id) {
      this.contact.company_id = id
      return new Promise((resolve, reject) => {
        if (this.contact.telephone[0].telephone_type === 'WhatsApp') this.contact.telephone[0].whatsapp_icon = true
        if (this.contact.name.length > 0) {
          contacts.createContact(this.contact).then(resContact => {
            this.contact.id = resContact.data.id
            this.fetchContacts()
            if (this.createContact) {
              this.contact.telephone[0].id = resContact.data.telephone.length > 0 ? resContact.data.telephone[0].id : null
            }
            resolve(resContact)
          }).catch(err => reject(err))
        }
      })
    },

    editContact() {
      contacts.editContact(this.contact).then(() => {
        this.fetchContacts()
      })
    },

    cancel() {
      this.setEdit(false)
      if (this.createCompany) {
        this.$router.push({ name: 'company' })
      } else {
        this.fetchCompany(this.$route.params.id)
      }
    },

    getAddress(cep) {
      this.$refs.cep.validate().then(success => {
        if (success) {
          const address = this.getAdressByCep(cep)
          this.companyData.address = address.logradouro
          this.companyData.neighborhood = address.bairro
          this.companyData.state = address.uf
          this.companyData.city = address.localidade
          this.companyData.address_number = address.complemento
        }
      })
    },
  },
}
</script>
